export const GET_TESTS = 'GET_TESTS';
export const GET_TESTS_SUCCESS = 'GET_TESTS_SUCCESS';
export const GET_TESTS_FAILURE = 'GET_TESTS_FAILURE';

export const GET_FILE_METADATA = 'GET_FILE_METADATA';
export const GET_FILE_METADATA_SUCCESS = 'GET_FILE_METADATA_SUCCESS';

export const CLEAR_ERROR_ON_GET_TESTS = 'CLEAR_ERROR_ON_GET_TESTS';

export const SET_TEST = 'SET_TEST';
export const GET_TEST_SUCCESS = 'GET_TEST_SUCCESS';
export const GET_TEST_FAILURE = 'GET_TEST_FAILURE';

export const CLEAR_SELECTED_TEST = 'CLEAR_SELECTED_TEST';
export const CLEAR_TESTS = 'CLEAR_TESTS';
export const PROCESSING_GET_TESTS = 'PROCESSING_GET_TESTS';

export const DELETE_TEST = 'DELETE_TEST';
export const DELETE_TEST_SUCCESS = 'DELETE_TEST_SUCCESS';
export const DELETE_TEST_FAILURE = 'DELETE_TEST_FAILURE';
export const CLEAR_ERROR_DELETE_TEST = 'CLEAR_ERROR_DELETE_TEST';
export const PROCESSING_DELETE_TEST = 'PROCESSING_DELETE_TEST';
export const CLEAR_ALL_SUCCESS_OPERATIONS_STATE = 'CLEAR_ALL_SUCCESS_OPERATIONS_STATE';

export const CREATE_TEST = 'CREATE_TEST';
export const CREATE_TEST_SUCCESS = 'CREATE_TEST_SUCCESS';
export const CREATE_TEST_FAILURE = 'CREATE_TEST_FAILURE';

export const IS_LOADING = 'IS_LOADING';
export const CLEAN_ALL_ERRORS = 'CLEAN_ALL_ERRORS';
export const INIT_CREATE_FORM = 'INIT_CREATE_FORM';
export const EDIT_TEST = 'EDIT_TEST';

export const GET_TEST = 'GET_TEST';


